import ObjClass from "./ObjClass";
import { SettingsHours } from "./SettingsHours";
import PersistentData from "./PersistentData";
import SettingsData from "./SettingsData";
import AccountService from "./services/AccountService";
import Service from "./Service";

const prefConv = {
	email: 'email',
	cell: 'cellPhone',
	home: 'homePhone',
	work: 'workPhone'
};

const contactOrder = ['cellPhone', 'homePhone', 'workPhone', 'email'];
const account = new AccountService();
const service = new Service();

export default class User extends ObjClass{

	_transformProp(p){
		p = super._transformProp(p);
		switch(p.toLowerCase()){
		case 'firstname':
			p = 'firstName';
			break;
		case 'lastname':
			p = 'lastName';
			break;
		case 'userid':
			p = 'userId';
			break;
		default:
			break;
		}

		return p;
	}

	get fullName(){
		return (this.firstName || '') + ' ' + (this.lastName || '');
	}

	get initials(){
		return (this.firstName.charAt(0) + this.lastName.charAt(0)).trim().toUpperCase();
	}

	/*get settings(){
        if(this._settings == null){
            this._settings = new UserSettings('Users/' + this.userId)
        }
        return this._settings;
    }*/



	static GetContact(user){
		let contact = user[prefConv[user.preferredContactMethod]];
		if(contact){
			return {value:contact, name:prefConv[user.preferredContactMethod]}
		}
		for(let i = 0; i < contactOrder.length; i++){
			let name = contactOrder[i];
			if(user[name]){
				return {value:user[name], name:name};
			}
		}
	}
}


export class UserSettings{
	constructor(dataPath, userId){
		let path = dataPath + '/' + (userId || account.userId);
		this.userId = (userId || account.userId);
		//this.hours = new SettingsHours(path);
		this.schedule = new UserSchedule(dataPath, userId);
		this.custom = new SettingsData(path, 'custom');
	}

	getData(key){
		return this.custom.getData(key);
	}

	setData(key, value){
		this.custom.setData(key, value);
	}

	/*loadSchedule(){
        return this.hours.serverExceptions('UserAvailabilityExceptions', {
            get:{
                userId: this.userId
            }
        }).then((results) => {
            return this.hours.serverDefaults('UserAvailabilities', {
                get:{
                    userId: this.userId
                }
            })
        })
    }*/
}

export class UserSchedule{
	constructor(path, userId){

		//super(path + '/' + (userId || account.userId));
		this.cache = new SettingsHours(path + '/' + (userId || account.userId));
		this.userId = userId;
	}

	load() {


		return this.getExceptions().then(() => this.getDefaultWeekHours());//.then(this.getExceptions)

		/*return this.cache.serverExceptions('UserAvailabilityExceptions', {
            get:{
                userId: this.userId
            }
        }).then((results) => {
            return this.cache.serverDefaults('UserAvailabilities', {
                get:{
                    userId: this.userId
                }
            })
        })*/
	}

	setDefaultWeekHours(defaults){

		let serverCache = this.cache.getServerDefaultsJSON();
		let serverData = this.cache.defaultCacheToServer(defaults);
		let userAvailabilityId = defaults.userAvailabilityId || serverCache.userAvailabilityId;
		let req = {};
		let method = (userAvailabilityId != null)? 'put':'post'
		let url = 'UserAvailabilities';
		serverData.userId = this.userId;
		serverData.clinicId = account.clinicId;

		if(userAvailabilityId){
			serverData.userAvailabilityId = userAvailabilityId;
			url = url + '/' + userAvailabilityId;
			this.cache.defaultWeekHours = defaults
			this.cache.setServerDefaultsJSON(serverData);
		}

		req[method] = serverData;
		return this.cache.serverDefaults(url, req)
	}

	getDefaultWeekHours(){
		return this.cache.serverDefaults('UserAvailabilities', {
			get:{
				userId:this.userId
			}
		});
	}

	setException(date, hours){
		this.cache.setDateHoursException(date, hours);
		let exception = this.cache.getServerExceptionJSON(date) || {};
		let serverData = this.cache.exceptionCacheToserver(hours, date);
		let req = {};
		let apiPath = 'UserAvailabilityExceptions';
		let method = (exception.id != null)? 'put':'post'
		serverData.userId = this.userId;
		serverData.clinicId = account.clinicId;

		if(exception.id){
			serverData.id = exception.id;
			apiPath = apiPath + '/' + exception.id;
		}

		req[method] = serverData;

		return this.cache.serverExceptions(apiPath , req);
	}

	getExceptions(){
		return this.cache.serverExceptions('UserAvailabilityExceptions', {
			get:{
				userId: this.userId
			}
		})
	}

	deleteException(date){
		let exception = this.cache.getServerExceptionJSON(date) || {};
		this.cache.deleteDateHoursException(date);
		return service.request('UserAvailabilityExceptions/' + exception.id , {
			delete:{
				id:exception.id
			}
		}).then((r)=>{
			return {response:r, exception:exception};
		})
	}

}



// WEBPACK FOOTER //
// ./src/api/User.js